import { useEffect } from 'react';
import noop from 'lodash/noop';

import type { DownloadCSVHandlers } from '../DownloadCSV.types';
import { PollingState } from '../DownloadCSV.types';

import type { UseDownloadCsvAnalyticsProps } from './useDownloadCsvAnalytics.types';

const analyticsLookup = (handlers?: DownloadCSVHandlers) => ({
	[PollingState.AbortedFilter]: {
		triggerEvent: handlers?.onPollingAborted ?? noop,
	},
	[PollingState.AbortedPage]: {
		triggerEvent: handlers?.onPollingAborted ?? noop,
	},
	[PollingState.Error]: {
		triggerEvent: handlers?.onPollingError ?? noop,
	},
	[PollingState.RetriesLimitExceeded]: {
		triggerEvent: noop,
	},
	[PollingState.Success]: {
		triggerEvent: handlers?.onPollingSuccess ?? noop,
	},
});

export const useDownloadCsvAnalytics = ({ handlers, state }: UseDownloadCsvAnalyticsProps): void => {
	useEffect(() => {
		if (state === PollingState.Inactive || state === PollingState.Polling) {
			return;
		}

		const { triggerEvent } = analyticsLookup(handlers)[state];

		triggerEvent?.();
	}, [state, handlers]);
};
